import { Rating } from "@smastrom/react-rating";
import "@smastrom/react-rating/style.css";

const StarRating = ({ number }) => {
	const count = number ?? 0;
	return <Rating value={count} readOnly className="max-w-[150px]" />;
};

export default StarRating;
